// extracted by mini-css-extract-plugin
module.exports = {"w1l1jlq1":"w1l1jlq1","ffcco1t":"ffcco1t","l39gj1b":"l39gj1b","s18327gu":"s18327gu"};